import { gql } from '@apollo/client';
/**
 * @const UpdateSaleItemPriceGloballyMutation
 * @since 1.0.0
 */
export const UpdateSaleItemPriceGloballyMutation = gql `
  mutation UpdateSaleItemPriceGloballyMutation(
    $input: UpdateSaleItemPriceGloballyInput!
  ) {
    updateSaleItemPriceGlobally(input: $input)
  }
`;
